export default [
    {
        key: 'expenseStandardModalMC',
        getComponent: function () { return import('./ExpenseStandardModal'); },
        width: 600,
        maskClosable: false,
        wrapClassName: 'vertical-center-modal select-member-modal',
    },
    {
        key: 'LogModal',
        getComponent: function () { return import('./LogModal'); },
        title: '下发记录',
        width: 800,
    },
];
